<template>
  <div :class="['suggestion', { on: isShowTips }]" ref="suggestionBox">
    <span class="handle" data-io-click="tracker"  @click="showSuggestion"
      ><i class="iconfont icon-arrow-fill"></i
    ></span>
    <!-- <div class="invite">
      <span class="tip">诚邀您与学科网携手打造 网校通</span>
      <span class="tip-1">请留下您的宝贵意见~！</span>
    </div> -->
    <!-- <div class="scan">
      <span class="qr-code"
        ><img
          :src="
            '//zxxkstatic.zxxk.com/ued/wxt-images/code.png' +
            '?_=' +
            Math.random()
          "
          alt=""
      /></span>
      <span class="explain"
        ><span class="txt">← 扫码加入内测群</span
        ><span class="btn" data-io-click="tracker"  @click="$emit('feedback', true)"
          >戳我留言反馈</span
        ></span
      >
    </div> -->
    <a href="https://www.zxxk.com/msfx/?source=wxtbanner" target="_blank">
      <img
        class="suggestion-ad-img"
        src="//zxxkstatic.zxxk.com/ued/wxt-images/mingshi-ad.png"
        alt=""
      />
    </a>
  </div>
</template>
<script>
import suggestion from "@/assets/js/mixin/suggestion";
export default {
  mixins: [suggestion],
  data() {
    return {
      img: "@/assets/images/code.png?_=" + Math.random(),
    };
  },
  mounted() {
    // this.firstOpen();
    // console.log("默认是否是打开的", this.isShowTips);
    // this.suggestionHeight();
  },
  methods: {
    // 显示反馈建议横幅
    showSuggestion() {
      this.isShowTips = !this.isShowTips;
    },
    // suggestionHeight() {
    //   this.$nextTick(() => {
    //     let realHeight =
    //       this.$refs.suggestionBox && this.$refs.suggestionBox.offsetHeight;
    //     console.log("realHeight", realHeight);
    //   });
    // },
  },
};
</script>
<style scoped lang="scss">
.suggestion {
  position: fixed;
  width: 100%;
  bottom: -332px;
  left: 0;
  padding: 20px 0 20px;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
  z-index: 3000;
  transition: all 2s;
  &.on {
    bottom: 0;
    .handle {
      .iconfont {
        transform: rotate(0);
      }
    }
  }
  .suggestion-ad-img {
    width: 818px;
    height: 292px;
    position: relative;
    right: -20px;
  }
  .handle {
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: -18px;
    width: 70px;
    height: 18px;
    background: url(../assets/images/arrow.png) no-repeat 0 1px;
    background-size: 100% auto;
    cursor: pointer;
    text-align: center;
    line-height: 18px;
    .iconfont {
      font-size: 14px;
      color: #669aff;
      display: inline-block;
      transition: all 0.2s;
      transform: rotate(-180deg);
    }
  }
  .scan,
  .invite {
    position: relative;
    display: inline-block;
    margin: 0 1px;
    border-radius: 10px;
    vertical-align: top;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: auto 100%;
    // &:before {
    //   position: absolute;
    //   right: -5px;
    //   width: 10px;
    //   height: 40px;
    //   background-size: 100% auto;
    //   content: "";
    // }
  }
  .invite {
    padding: 18px 30px 18px 24px;
    background-image: url(../assets/images/border-1.png);
    text-align: left;
    .tip {
      display: block;
      font-size: 16px;
      font-weight: 700;
      color: #f9df91;
      line-height: 16px;
    }
    .tip-1 {
      margin-top: 16px;
      display: block;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      line-height: 18px;
    }
  }
  .scan {
    padding: 6px 17px;
    background-image: url(../assets/images/border.png);
    .explain {
      display: inline-block;
      vertical-align: top;
      .txt {
        display: block;
        color: #e6e7e9;
        font-size: 14px;
        color: #e6e7e9;
        line-height: 14px;
      }
      .btn {
        margin-top: 13px;
        display: block;
        width: 132px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        background: #0057ff;
        cursor: pointer;
        border-radius: 21px;
        font-weight: 700;
        color: #fff;
        &:hover {
          background: #669aff;
        }
      }
    }
    .qr-code {
      display: inline-block;
      vertical-align: top;
      margin-right: 8px;
      width: 76px;
      height: 76px;
      img {
        display: block;
        width: 100%;
        background: #fff;
      }
    }
  }
}
</style>
